import Table from "../../../Components/Table/Table";
import StatusColorful from "../../../Components/Table/Components/StatusColorful";
import SVG from "../../../Components/SVG";
import Custom from "../../../Components/Buttons/Custom";
import { useEffect, useState } from "react";
import TableLoading from "../../../Components/Loader/TableLoading";
import { useNavigate } from "react-router-dom";

export default function Missions({ rulesData, accountData, ruleLoading }) {
  const navigate = useNavigate();
  const [targetStatus, setTargetStatus] = useState("stable");
  const [totalDrawdownStatus, setTotalDrawdownStatus] = useState("stable");
  const [dailyDrawdownStatus, setDailyDrawdownStatus] = useState("stable");
  const [tradeDrawdownStatus, setTradeDrawdownStatus] = useState("stable");
  const [minTradingDaysStatus, setMinTradingDaysStatus] = useState("stable");
  const [consRuleStatus, setConsRuleStatus] = useState("stable");
  const [scalpProfitStatus, setScalpProfitStatus] = useState("stable");

  useEffect(() => {
    console.log("Account Data in Missions:", rulesData);
    if (rulesData !== null && rulesData !== undefined) {
      // Example logic to determine target status based on rulesData
      if (rulesData.status === "live") {
        if (
          Number(rulesData.rules.profit_target.current_state) >=
          Number(rulesData.rules.profit_target.definition)
        ) {
          setTargetStatus("passed");
        } else if (
          Number(rulesData.rules.profit_target.current_state) <
            Number(rulesData.rules.profit_target.definition) &&
          Number(rulesData.rules.profit_target.current_state) >= 0
        ) {
          setTargetStatus("stable");
        } else {
          setTargetStatus("danger");
        }

        if (rulesData.rules.max_drawdown_limit.violated) {
          setTotalDrawdownStatus("failed");
        } else {
          setTotalDrawdownStatus("stable");
        }

        if (rulesData.rules.daily_drawdown_limit.violated) {
          setDailyDrawdownStatus("failed");
        } else {
          setDailyDrawdownStatus("stable");
        }

        if (rulesData.rules.trade_drawdown_limit.violated) {
          setTradeDrawdownStatus("failed");
        } else {
          setTradeDrawdownStatus("stable");
        }

        if (
          Number(rulesData.trading_days) >= Number(rulesData.min_trading_days)
        ) {
          setMinTradingDaysStatus("passed");
        } else {
          setMinTradingDaysStatus("danger");
        }
        if (rulesData.rules.consistency_rule.violated) {
          setConsRuleStatus("danger");
        } else {
          setConsRuleStatus("stable");
        }
        if (rulesData.rules.fast_scalp.violated) {
          setScalpProfitStatus("danger");
        } else {
          setScalpProfitStatus("stable");
        }
      } else {
        if (
          Number(rulesData.rules.profit_target.current_state) >=
          Number(rulesData.rules.profit_target.definition)
        ) {
          setTargetStatus("passed");
        } else {
          setTargetStatus("failed");
        }

        if (rulesData.rules.max_drawdown_limit.violated) {
          setTotalDrawdownStatus("failed");
        } else {
          setTotalDrawdownStatus("stable");
        }

        if (rulesData.rules.daily_drawdown_limit.violated) {
          setDailyDrawdownStatus("failed");
        } else {
          setDailyDrawdownStatus("stable");
        }

        if (rulesData.rules.trade_drawdown_limit.violated) {
          setTradeDrawdownStatus("failed");
        } else {
          setTradeDrawdownStatus("stable");
        }

        if (
          Number(rulesData.trading_days) >= Number(rulesData.min_trading_days)
        ) {
          setMinTradingDaysStatus("passed");
        } else {
          setMinTradingDaysStatus("failed");
        }
        if (rulesData.rules.consistency_rule.violated) {
          setConsRuleStatus("failed");
        } else {
          setConsRuleStatus("passed");
        }
        if (rulesData.rules.fast_scalp.violated) {
          setScalpProfitStatus("failed");
        } else {
          setScalpProfitStatus("passed");
        }
      }
    }
  }, [rulesData]);
  return (
    <div className="w-full h-fit flex flex-col p-5 gap-5 rounded-2xl bg-zi-bg2-light dark:bg-zi-bg2-dark overflow-hidden min-h-0">
      <div className="w-full flex justify-between items-center">
        <h2 className="flex gap-2.5 items-center">
          <SVG
            name="mission"
            classname="size-5 stroke-zi-blue-dark dark:stroke-white"
          />
          <span className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
            مأموریت‌های چالش
          </span>
        </h2>

        <Custom
          onClick={() => navigate("/rule/challenge")}
          text="قوانین چالش‌ها"
          href=""
          className="bg-zi-bg2-light dark:bg-zi-bg2-dark !px-5 !py-2 !rounded-full text-zi-text-light dark:text-zi-text-dark ring-1 ring-zi-border-dark dark:ring-zi-border-light hocus:bg-zi-bg1-light hocus:dark:bg-zi-bg1-dark"
        />
      </div>

      {ruleLoading ? (
        <Table
          isEnglish={[1, 2]}
          columns={[
            { key: "title", label: "عنوان" },
            { key: "current", label: "وضعیت فعلی" },
            { key: "metric", label: "معیار" },
            {
              key: "status",
              label: "وضعیت",
              render: (value) =>
                value === "passed" ? (
                  <StatusColorful
                    SVGName="tick"
                    text="تکمیل شده"
                    className="w-24"
                    color="blue"
                  />
                ) : value === "stable" ? (
                  <StatusColorful
                    SVGName="stall"
                    text="پایدار"
                    className="w-24"
                    color="green"
                  />
                ) : value === "danger" ? (
                  <StatusColorful
                    SVGName="danger"
                    text="ناپایدار"
                    className="w-24"
                    color="yellow"
                  />
                ) : value === "failed" ? (
                  <StatusColorful
                    SVGName="failed"
                    text="رد شده"
                    className="w-24"
                    color="red"
                  />
                ) : (
                  ""
                ),
            },
          ]}
          data={[]}
        />
      ) : accountData?.phase?.phase_type !== "funded" ? (
        <Table
          isEnglish={[1, 2]}
          columns={[
            { key: "title", label: "عنوان" },
            { key: "current", label: "وضعیت فعلی" },
            { key: "metric", label: "معیار" },
            {
              key: "status",
              label: "وضعیت",
              render: (value) =>
                value === "passed" ? (
                  <StatusColorful
                    SVGName="tick"
                    text="تکمیل شده"
                    className="w-24"
                    color="blue"
                  />
                ) : value === "stable" ? (
                  <StatusColorful
                    SVGName="stall"
                    text="پایدار"
                    className="w-24"
                    color="green"
                  />
                ) : value === "danger" ? (
                  <StatusColorful
                    SVGName="danger"
                    text="ناپایدار"
                    className="w-24"
                    color="yellow"
                  />
                ) : value === "failed" ? (
                  <StatusColorful
                    SVGName="failed"
                    text="رد شده"
                    className="w-24"
                    color="red"
                  />
                ) : (
                  ""
                ),
            },
          ]}
          data={[
            {
              title: "سود هدف",
              current:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.profit_target?.current_state,
                      ).toFixed(2) || "-"
                    } %`
                  : "۰ %",
              metric:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.profit_target?.definition,
                      ).toFixed(2) || "-"
                    } %`
                  : "۵ %",
              status: targetStatus,
            },
            {
              title: "حد ضرر کلی",
              current:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.max_drawdown_limit?.current_state,
                      ).toFixed(2) || "-"
                    } %`
                  : "۰ %",
              metric:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.max_drawdown_limit?.definition,
                      ).toFixed(2) || "-"
                    } %`
                  : "۵ %",
              status: totalDrawdownStatus,
            },
            {
              title: "حد ضرر روزانه",
              current:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.daily_drawdown_limit?.current_state,
                      ).toFixed(2) || "-"
                    } %`
                  : "۰ %",
              metric:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.daily_drawdown_limit?.definition,
                      ).toFixed(2) || "-"
                    } %`
                  : "۵ %",
              status: dailyDrawdownStatus,
            },
            {
              title: "حد ضرر هر معامله",
              current:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.trade_drawdown_limit?.current_state,
                      ).toFixed(2) || "-"
                    } %`
                  : "۰ %",
              metric:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.trade_drawdown_limit?.definition,
                      ).toFixed(2) || "-"
                    } %`
                  : "۵ %",
              status: tradeDrawdownStatus,
            },
            {
              title: "حداقل روزهای معاملاتی",
              current:
                rulesData != null ? `${rulesData.trading_days} روز` : "۰ روز",
              metric:
                rulesData != null
                  ? `${rulesData.min_trading_days} روز`
                  : "۰ روز",
              status: minTradingDaysStatus,
            },

            // ✅ Consistency rule – only if definition != null
            ...(rulesData?.rules?.consistency_rule?.definition != null
              ? [
                  {
                    title: "حداکثر سود هر روز معاملاتی از سود کل",
                    current: `${
                      Number(
                        rulesData?.rules?.consistency_rule?.current_state,
                      ).toFixed(2) || "-"
                    } %`,
                    metric: `${
                      Number(
                        rulesData?.rules?.consistency_rule?.definition,
                      ).toFixed(2) || "-"
                    } %`,
                    status: consRuleStatus,
                  },
                ]
              : []),

            // ✅ Fast scalp – only if definition != null
            ...(rulesData?.rules?.fast_scalp?.definition != null
              ? [
                  {
                    title: "مجموع سود مجاز معاملات اسکلپ",
                    current: `${
                      Number(
                        rulesData?.rules?.fast_scalp?.current_state,
                      ).toFixed(2) || "-"
                    } %`,
                    metric: `${
                      Number(rulesData?.rules?.fast_scalp?.definition).toFixed(
                        2,
                      ) || "-"
                    } %`,
                    status: scalpProfitStatus,
                  },
                ]
              : []),
          ]}
        />
      ) : (
        <Table
          isEnglish={[1, 2]}
          columns={[
            { key: "title", label: "عنوان" },
            { key: "current", label: "وضعیت فعلی" },
            { key: "metric", label: "معیار" },
            {
              key: "status",
              label: "وضعیت",
              render: (value) =>
                value === "passed" ? (
                  <StatusColorful
                    SVGName="tick"
                    text="تکمیل شده"
                    className="w-24"
                    color="blue"
                  />
                ) : value === "stable" ? (
                  <StatusColorful
                    SVGName="stall"
                    text="پایدار"
                    className="w-24"
                    color="green"
                  />
                ) : value === "danger" ? (
                  <StatusColorful
                    SVGName="danger"
                    text="ناپایدار"
                    className="w-24"
                    color="yellow"
                  />
                ) : value === "failed" ? (
                  <StatusColorful
                    SVGName="failed"
                    text="رد شده"
                    className="w-24"
                    color="red"
                  />
                ) : (
                  ""
                ),
            },
          ]}
          data={[
            {
              title: "حد ضرر کلی",
              current:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.max_drawdown_limit?.current_state,
                      ).toFixed(2) || "-"
                    } %`
                  : "۰ %",
              metric:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.max_drawdown_limit?.definition,
                      ).toFixed(2) || "-"
                    } %`
                  : "۵ %",
              status: totalDrawdownStatus,
            },
            {
              title: "حد ضرر روزانه",
              current:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.daily_drawdown_limit?.current_state,
                      ).toFixed(2) || "-"
                    } %`
                  : "۰ %",
              metric:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.daily_drawdown_limit?.definition,
                      ).toFixed(2) || "-"
                    } %`
                  : "۵ %",
              status: dailyDrawdownStatus,
            },
            {
              title: "حد ضرر هر معامله",
              current:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.trade_drawdown_limit?.current_state,
                      ).toFixed(2) || "-"
                    } %`
                  : "۰ %",
              metric:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.trade_drawdown_limit?.definition,
                      ).toFixed(2) || "-"
                    } %`
                  : "۵ %",
              status: tradeDrawdownStatus,
            },
            // ✅ Consistency rule – only if definition != null
            ...(rulesData?.rules?.consistency_rule?.definition != null
              ? [
                  {
                    title: "حداکثر سود هر روز معاملاتی از سود کل",
                    current: `${
                      Number(
                        rulesData?.rules?.consistency_rule?.current_state,
                      ).toFixed(2) || "-"
                    } %`,
                    metric: `${
                      Number(
                        rulesData?.rules?.consistency_rule?.definition,
                      ).toFixed(2) || "-"
                    } %`,
                    status: consRuleStatus,
                  },
                ]
              : []),

            // ✅ Fast scalp – only if definition != null
            ...(rulesData?.rules?.fast_scalp?.definition != null
              ? [
                  {
                    title: "مجموع سود مجاز معاملات اسکلپ",
                    current: `${
                      Number(
                        rulesData?.rules?.fast_scalp?.current_state,
                      ).toFixed(2) || "-"
                    } %`,
                    metric: `${
                      Number(rulesData?.rules?.fast_scalp?.definition).toFixed(
                        2,
                      ) || "-"
                    } %`,
                    status: scalpProfitStatus,
                  },
                ]
              : []),
          ]}
        />
      )}
      {ruleLoading && (
        <div className="w-full flex justify-center items-center gap-2">
          <p className="text-[#808080]">در حال بارگذاری</p>
          <TableLoading className="text-[#808080]" />
        </div>
      )}
    </div>
  );
}
